import { CHANNEL_LABELS, ChannelKey } from '@constants';

export const getChannelLabel = (channel?: string): string => {
  if (!channel) return '';

  return CHANNEL_LABELS[channel as ChannelKey] ?? channel;
};
